var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrvtoLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.02497 9.21088C6.88318 9.21088 5.95402 8.28247 5.95402 7.14068C5.95402 5.99889 6.88318 5.06972 8.02497 5.06972C9.16676 5.06972 10.0952 5.99889 10.0952 7.14068C10.0952 8.28247 9.16676 9.21088 8.02497 9.21088ZM12.2728 2.51979C11.1144 1.32504 9.60562 0.666748 8.02497 0.666748C6.4428 0.666748 4.93405 1.32504 3.77486 2.52055C2.59826 3.73422 1.95208 5.36481 2.00277 6.99464C2.14578 11.6133 7.58611 15.2096 7.8184 15.3602L8.02194 15.4926L8.22775 15.3625C8.45928 15.2157 13.9034 11.7063 14.0472 6.99389C14.0971 5.36481 13.4502 3.73347 12.2728 2.51979Z",
    fill: "#44455F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrvtoLocation);
export default __webpack_public_path__ + "static/media/trvto_location.16bc3e33ba33bba709281f6d07676e3f.svg";
export { ForwardRef as ReactComponent };